module.exports = __webpack_public_path__ + "static/shady-grove-blacksmith-a64363ca76bb335cb28517d4ee9c07f2.gif";